import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "card-label" }, "Senarai Transaksi Perjawatan")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_9 = { class: "text-dark fw-bolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTDatatableBackend = _resolveComponent("KTDatatableBackend")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_KTDatatableBackend, {
        "table-header": _ctx.headerConfig,
        "table-data": _ctx.paginatedData,
        total: _ctx.totalItems,
        loading: _ctx.loading,
        "rows-per-page": _ctx.pagination.limit,
        page: _ctx.pagination.page,
        "sort-by": _ctx.pagination.sortBy,
        "sort-order": _ctx.pagination.sortOrder,
        onCurrentChange: _ctx.handlePageChange,
        onSort: _ctx.handleSortChange,
        "enable-items-per-page-dropdown": false
      }, {
        "cell-jenis_transaksi": _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(_ctx.formatJenisTransaksi2(row.jenis_transaksi2)), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.formatJenisTransaksi(row.jenis_transaksi2, row.jenis_transaksi)), 1)
        ]),
        "cell-perjawatan_kumpulan": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.perjawatan?.kumpulan_perjawatan || '-'), 1)
        ]),
        "cell-perjawatan_skim": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.perjawatan?.kod_skim_perkhidmatan || '-'), 1)
        ]),
        "cell-perjawatan_jawatan": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.perjawatan?.jawatan || '-'), 1)
        ]),
        "cell-perjawatan_bahagian": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.perjawatan?.Bahcaw2?.nama || '-'), 1)
        ]),
        "cell-no_rujukan_surat": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.no_rujukan_surat || '-'), 1)
        ]),
        "cell-tarikh_kuat_kuasa": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(row.tarikh_kuat_kuasa)), 1)
        ]),
        "cell-is_gunasama": _withCtx(({ row }) => [
          _createElementVNode("span", {
            class: _normalizeClass(`badge badge-${row.is_gunasama === '1' ? 'success' : (row.is_gunasama === '0' ? 'secondary' : 'light')}`)
          }, _toDisplayString(row.is_gunasama === '1' ? 'Ya' : (row.is_gunasama === '0' ? 'Tidak' : '-')), 3)
        ]),
        "cell-catatan_urusetia": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.catatan_urusetia || '-'), 1)
        ]),
        "cell-lampiran_meta": _withCtx(({ row }) => [
          (row.lampiran_meta && row.lampiran_meta.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.lampiran_meta, (file, index) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: file.id,
                    href: file.url,
                    target: "_blank",
                    class: "btn btn-sm btn-light-primary me-1 mb-1"
                  }, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(file.nama_asal || `Lampiran ${index + 1}`), 1)
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
        ]),
        "cell-created_at": _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(row.created_at)), 1)
        ]),
        "info-footer": _withCtx(() => [
          _createElementVNode("h4", _hoisted_9, "JUMLAH REKOD: " + _toDisplayString(_ctx.totalItems), 1)
        ]),
        _: 1
      }, 8, ["table-header", "table-data", "total", "loading", "rows-per-page", "page", "sort-by", "sort-order", "onCurrentChange", "onSort"])
    ])
  ]))
}